import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from './authentication.service';
import { LoggerServiceModule } from '../logger/logger.module';
import {
	MsalBroadcastService,
	MsalGuard,
	MsalInterceptor,
	MsalModule,
	MsalService,
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationServiceFactory } from './authentication-service.factory';

@NgModule({
	declarations: [],
	imports: [ CommonModule, LoggerServiceModule, MsalModule ],
	exports: [],
	providers: [
		AuthenticationService,
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		{
			provide: MSAL_INSTANCE,
			useFactory: AuthenticationServiceFactory.msalInstanceFactory
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: AuthenticationServiceFactory.msalGuardConfigFactory
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: AuthenticationServiceFactory.msalInterceptorConfigFactory
		}
	]
})
export class AuthenticationServiceModule {}
